var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"header-container",staticClass:"header-container"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.displayedMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }